/* ==========================================================================
   express-wallet-filter.js: Express-Buttons im Warenkorb auf erlaubte Wallets
   begrenzen (seit 3.10.26, Kathrin: "nur PayPal unter Kasse").

   Shopify rendert <shopify-accelerated-checkout-cart wallet-configs="[...]">
   mit ALLEN aktiven Wallets (Shop Pay, Apple Pay, PayPal, Google Pay; je nach
   Geraet). Per CSS ausblenden ginge nicht sauber: die Wallet-Plaetze liegen im
   geschlossenen Shadow DOM und blieben als Luecken stehen. Deshalb wird das
   Element durch eine Kopie ersetzt, deren wallet-configs nur die erlaubten
   Wallets enthaelt.

   Erlaubte Wallets: data-express-wallets am Container (kommagetrennt, z. B.
   "paypal"), aus dem Section-/Block-Setting express_wallets in
   sections/cart-drawer.liquid bzw. sections/main-cart.liquid. Leer = alle.
   Ist keine erlaubte Wallet verfuegbar, verschwindet der Container ganz.

   Laeuft fuer vorhandene Elemente und fuer neu eingesetzte (der Drawer wird
   nach jeder Warenkorb-Aenderung per Section-Rendering neu befuellt; Skripte
   im neuen HTML laufen dabei nicht, deshalb der MutationObserver).
   Der Shopify-Checkout selbst bleibt unberuehrt.
   ========================================================================== */
(function () {
  if (window.__tosExpressFilter) return;
  window.__tosExpressFilter = true;
  var SEL = 'shopify-accelerated-checkout-cart';

  function allowedFor(el) {
    var host = el.closest('[data-express-wallets]');
    if (!host) return null;
    return (host.getAttribute('data-express-wallets') || '')
      .split(',')
      .map(function (s) { return s.trim().toLowerCase(); })
      .filter(Boolean);
  }

  function filter(el) {
    if (!el || el.__tosFiltered) return;
    var allowed = allowedFor(el);
    if (!allowed || !allowed.length) return;
    var cfg;
    try { cfg = JSON.parse(el.getAttribute('wallet-configs') || ''); } catch (e) { return; }
    if (!Array.isArray(cfg)) return;
    var keep = cfg.filter(function (w) { return w && allowed.indexOf(String(w.name).toLowerCase()) !== -1; });
    var host = el.closest('[data-express-wallets]');
    if (!keep.length) {
      el.__tosFiltered = true;
      if (host) host.hidden = true;
      el.remove();
      return;
    }
    if (host) host.hidden = false;
    if (keep.length === cfg.length) { el.__tosFiltered = true; return; }
    var clone = el.cloneNode(false);
    clone.__tosFiltered = true;
    clone.setAttribute('wallet-configs', JSON.stringify(keep));
    el.replaceWith(clone);
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches(SEL)) filter(root);
    root.querySelectorAll(SEL).forEach(filter);
  }

  scan(document);
  new MutationObserver(function (list) {
    list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); });
  }).observe(document, { childList: true, subtree: true });
})();
